module.exports = __webpack_public_path__ + "static/june-1-72341022e9d70e878248bbb23c17bb2c.png";